module.exports = __webpack_public_path__ + "032141fa001e07b0030af87a225daeff.svg";